var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Box, FormControl, Grid, InputLabel, MenuItem, Select, Typography, useTheme, } from "@mui/material";
import { useContext, useEffect, useState, } from "react";
import { statusBgColor, statusTextColor, } from "../../../../application/common/utils/column-helper";
import { useTranslation } from "react-i18next";
import LeadsApi from "../../../../infrastructure/api/pages/lead-api";
import UsersApi from "../../../../infrastructure/api/pages/users-api";
import { UserRolesPermissionsContext } from "../../../../context/UserRolesPermissionsContext";
import { checkManage } from "../../../../application/common/utils/roles-helper";
import { Modules } from "../../../../application/common/enums/screen-name";
import { toast } from "react-toastify";
import { getStatusOptionsForDropdown } from "../../../../application/common/utils/lead-status-helper";
const ActionSection = ({ leadId, refresh, setIsLeadSpecial, setRefreshData, lead, }) => {
    const theme = useTheme();
    const [status, setStatus] = useState(1);
    // const { getProfile } = useContext(AuthenticationContext);
    const [result, setResult] = useState();
    const [users, setUsers] = useState([]);
    const { t: translate } = useTranslation();
    // const [lead, setLead] = useState<LeadDto>();
    const { RolesPermissions } = useContext(UserRolesPermissionsContext);
    const getData = (filter) => __awaiter(void 0, void 0, void 0, function* () {
        try {
            var result = yield UsersApi.getResponsiblePersons(filter);
            if (result.data) {
                setUsers(result.data);
            }
        }
        catch (error) {
            console.error("Error while fetching adminusers:", error);
        }
    });
    useEffect(() => {
        getData(false);
    }, []);
    const saveStatus = (param) => __awaiter(void 0, void 0, void 0, function* () {
        let obj = lead;
        if (obj === null || obj === void 0 ? void 0 : obj.status) {
            obj.status = param;
        }
        // await LeadsApi.getLeadByLeadId(leadId).then((lead) => {
        //   setLead(lead.data);
        //   obj = lead.data;
        //   obj.status = param;
        // });
        if (obj) {
            yield LeadsApi.updateLead(obj).then(() => {
                setRefreshData((prev) => !prev);
                toast.success(translate("UpdatedSuccessfully"));
            });
        }
    });
    useEffect(() => {
        if (lead) {
            // await LeadsApi.getLeadByLeadId(leadId).then((lead) => {
            setIsLeadSpecial(lead.status === 6);
            // setLead(lead.data);
            setStatus(lead.status);
            setResult(lead.responsiblePersonId);
            // });
        }
    }, [lead]);
    const handleChange = (e) => __awaiter(void 0, void 0, void 0, function* () {
        setResult(e.target.value);
        updateObject(e.target.value);
    });
    const updateObject = (value) => __awaiter(void 0, void 0, void 0, function* () {
        let obj = lead;
        obj.responsiblePersonId = value;
        // await LeadsApi.getLeadByLeadId(leadId).then((lead) => {
        //   setLead(lead.data);
        //   obj = lead.data;
        // });
        yield LeadsApi.updateLead(obj).then(() => {
            setRefreshData((prev) => !prev);
            toast.success(translate("UpdatedSuccessfully"));
        });
    });
    return (_jsxs(Grid, { container: true, size: 12, sx: {
            justifyContent: "space-between",
            bgcolor: theme.palette.common.white,
            borderRadius: "24px",
            padding: "var(--2, 16px) var(--4, 32px)",
        }, children: [_jsxs(Grid, { sx: { gap: "12px" }, size: 6, children: [_jsx(Box, { children: _jsx(InputLabel, { id: "simple-select-label", children: _jsx(Typography, { variant: "h6", sx: { fontSize: "16px" }, children: "Status" }) }) }), _jsx(Box, { children: _jsx(FormControl, { fullWidth: true, variant: "standard", size: "medium", children: _jsx(Select, { disableUnderline: true, labelId: "simple-select-status", id: "simple-select-status", value: status, onChange: (e) => {
                                    if (e.target.value === 0) {
                                        setStatus(undefined);
                                    }
                                    else {
                                        setStatus(e.target.value);
                                        saveStatus(e.target.value);
                                    }
                                }, children: getStatusOptionsForDropdown(lead === null || lead === void 0 ? void 0 : lead.status).map((statusOption) => {
                                    return (_jsx(MenuItem, { value: statusOption.value, disabled: !checkManage(RolesPermissions, Modules.Leads) || statusOption.deprecated, children: _jsx(Box, { sx: [{
                                                    bgcolor: statusBgColor[statusOption.value],
                                                    padding: 1,
                                                    borderRadius: 2
                                                }, statusOption.deprecated ? {
                                                    opacity: 0.7,
                                                    position: 'relative'
                                                } : {}], children: _jsxs(Typography, { variant: "h4", sx: {
                                                    color: statusTextColor[statusOption.value],
                                                    overflow: "hidden",
                                                    whiteSpace: "nowrap",
                                                    textOverflow: "ellipsis",
                                                    display: "block",
                                                    maxWidth: 250,
                                                    fontStyle: statusOption.deprecated ? 'italic' : 'normal'
                                                }, children: [translate(statusOption.translationKey), statusOption.deprecated && ` (${translate("Deprecated")})`] }) }) }, statusOption.value));
                                }) }) }) })] }), _jsxs(Grid, { sx: { gap: "12px" }, size: 6, children: [_jsx(Box, { children: _jsx(InputLabel, { id: "simple-select-label", children: _jsx(Typography, { variant: "h6", sx: { fontSize: "16px" }, children: translate("ResponsiblePerson") }) }) }), _jsx(Box, { children: _jsx(FormControl, { fullWidth: true, variant: "standard", size: "medium", children: _jsxs(Select, { labelId: "simple-select-label", id: "simple-select", value: result ? result : "Niet-toegewezen leads", disabled: !checkManage(RolesPermissions, Modules.Leads), onChange: (e) => {
                                    {
                                        checkManage(RolesPermissions, Modules.Leads) &&
                                            handleChange(e);
                                    }
                                }, children: [(lead === null || lead === void 0 ? void 0 : lead.responsiblePersonId) &&
                                        !users.some((u) => u.id === lead.responsiblePersonId) && (_jsx(MenuItem, { value: lead.responsiblePersonId, children: lead.responsiblePersonName || "Unknown User" }, lead.responsiblePersonId)), (Array.isArray(users) ? users : []).map((user) => (_jsx(MenuItem, { value: user.id, children: user.firstName || user.lastName
                                            ? `${user.firstName} ${user.lastName}`
                                            : "Unknown User" }, user.id)))] }) }) })] })] }));
};
export default ActionSection;
